// Bir bildirimin türüne (ve taşıdığı ID'ye) göre yönlendirileceği uygulama içi rotayı döner.
// Rota yoksa null döner (tıklamada yalnızca okundu işaretlenir, yönlendirme yapılmaz).
export function routeForNotification(n) {
  if (!n) return null;
  const t = n.type || "";

  // İzinle ilgili tüm bildirimler → izinler sayfası (mümkünse ilgili izin detayı açılır).
  if (
    t.startsWith("leave") ||
    t === "board_signature_required" ||
    t === "doc_verification_flag" ||
    t === "return_to_work"
  ) {
    return n.leave_id ? `/leaves?focus=${n.leave_id}` : "/leaves";
  }

  // Bordro bildirimleri.
  if (t === "payroll") return n.payroll_id ? `/payroll?focus=${n.payroll_id}` : "/payroll";
  if (t === "payroll_rejected") return n.payroll_id ? `/payroll-admin?focus=${n.payroll_id}` : "/payroll-admin";

  if (t === "promotion") return "/promotions";
  if (t === "survey") return "/surveys";
  if (t === "announcement") return "/announcements";
  if (t === "salary_approval") return "/hr-center";
  if (t === "salary_status") return "/settings";
  if (t === "signature_change_request" || t === "signature_change_status") return "/settings";
  if (t === "pending_registration") return "/pending";
  if (t === "hr_password_change_request" || t === "password_reset_request") return "/personnel";
  if (t === "device_approval_request") return "/settings";
  if (t === "birthday") return "/";

  return null;
}
